import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cls from 'classnames';
import { string, node } from 'prop-types';

import s from './index.css';

function Select({ className, children, ...rest }) {
  return (
    <div className={cls(className, s.root)}>
      <select className={s.select} {...rest}>
        {children}
      </select>
      <i className={cls('material-icons', s.iconDown)}>arrow_drop_down</i>
    </div>
  );
}

Select.propTypes = {
  className: string,
  children: node.isRequired,
};

Select.defaultProps = {
  className: '',
};

export default withStyles(s)(Select);
